import { searchParam, useSetSearch } from '@luminovo/design-system';
import { ComponentMetricIdSchema } from '@luminovo/monitoring-contracts';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import { ComponentSavingsPage } from '@/areas/market-insights/MarketInsights/pages/ComponentSavingsPage/ComponentSavingsPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/components/pricing')({
    // Access is enforced by the authenticated monitoring layout.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: z.object({
        baseline: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        comparison: searchParam.enum(ComponentMetricIdSchema.enum, 'optional'),
        period: z.string().optional(),
        ipn: z.string().optional(),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const baseline = Route.useSearch({ select: (search) => search.baseline });
    const comparison = Route.useSearch({ select: (search) => search.comparison });
    const period = Route.useSearch({ select: (search) => search.period });
    const ipn = Route.useSearch({ select: (search) => search.ipn });
    const onSearchChange = useSetSearch();
    return (
        <ComponentSavingsPage
            baseline={baseline}
            comparison={comparison}
            period={period}
            ipn={ipn}
            onSearchChange={onSearchChange}
        />
    );
}
